import React, { useState } from "react";
import styles from "./style.module.scss";
import nuvie from "../../../../../../../images/v2/nuvei.png";
import DropDown from "../../../../../components/DropDown/DropDown";
import KebabIcon from "../../../../../assets/svg/icons/common/kebab";
import Checkbox from "../../../../../components/Checkbox/Index";
import CheckIcon from "../../../../../assets/svg/icons/common/CheckCircle";
import CrossInCircle from "../../../../../assets/svg/icons/common/CrossInCircle";
import config from "../../../../../../config";
import useProcessorStore from "../../../../../stores/processor";
import ConfirmationModal from "../../../../application/components/ConfirmationModal/ConfirmationModal";
import { updateBank } from "../../../../../../api";
import toast from "react-hot-toast";

const Row = ({ data, fetchData }) => {
  const selectedBanks = useProcessorStore((state) => state.selectedBanks);
  const setSelectedBanks = useProcessorStore((state) => state.setSelectedBanks);
  const setIsEdit = useProcessorStore((state) => state.setIsEdit);
  const setAddModal = useProcessorStore((state) => state.setAddModal);
  const setActiveBank = useProcessorStore((state) => state.setActiveBank);
  const [deactivateConfirmModal, setDeactivateConfirmModal] = useState(false);

  const dropDownOptions = [
    {
      text: "Edit",
      type: "normal",
      onClick: () => {
        setIsEdit(true);
        setAddModal(true);
        setActiveBank(data);
      },
    },
    {
      text: "Deactivate",
      type: "normal",
      onClick: () => {
        setDeactivateConfirmModal(true);
      },
    },
  ];

  const onChange = (event) => {
    const bankId = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedBanks([...selectedBanks, bankId]);
    } else {
      setSelectedBanks(selectedBanks.filter((id) => id !== bankId));
    }
  };

  const onDeactivate = async () => {
    const toastId = toast.loading('Deactivating processor...');
    const submitData = {
      id: data?.id,
      status: 0,
      name: data?.name,
    }
    try {
      const response = await updateBank(submitData);
      if (response?.status) {
        toast.success('Processor deactivated successfully', { id: toastId });
        fetchData();
      } else {
        toast.error('Failed to deactivate processor', { id: toastId });
      }
    } catch (error) {
      toast.error('Failed to deactivate processor', { id: toastId });
    } finally {
      setDeactivateConfirmModal(false);
    }
  }

  return (
    <>
      <tr className={styles.tbodyRow}>
        <td className={`${styles.td} `}>
          <Checkbox
            checked={selectedBanks?.includes(String(data?.id))}
            value={String(data?.id)}
            onChange={onChange}
          />
        </td>
        <td className={`${styles.td}`}>
          <span>{data?.id}</span>
        </td>
        <td className={`${styles.td}`}>
          <div className={styles.flex}>
            <img
              src={`${config.paymentcloud.STRATUS_URL}bank-image/${data?.id}`}
              className={styles.logo}
            />
            <span>{data?.name}</span>
          </div>
        </td>
        <td className={`${styles.td}`}>
          <div className={styles.flex}>
            {data?.status === 1 ? (
              <>
                <CheckIcon />
                <span>Active</span>
              </>
            ) : (
              <>
                <CrossInCircle />
                <span>Inactive</span>
              </>
            )}
          </div>
        </td>
        <td className={`${styles.td}`}>
          <DropDown options={dropDownOptions}>
            <KebabIcon />
          </DropDown>
        </td>
      </tr>

      {deactivateConfirmModal && (
        <ConfirmationModal
          open={deactivateConfirmModal}
          onClose={() => setDeactivateConfirmModal(false)}
          message={"Are you sure you want to deactivate this processor?"}
          onConfirmClick={onDeactivate}
          submitButtonText={"Deactivate"}
        />
      )}
    </>
  );
};

export default Row;
